import { type MetaFunction } from '@remix-run/node'

export const meta: MetaFunction = () => [
	{ title: 'Safe Winter Driving Tips' },
	{
		name: 'description',
		content: 'How to drive safely in the winter.',
	},
]
export default function Component() {
	return (
		<>
			<h1 className="py-3 text-4xl font-black">Safe Winter Driving Tips</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				By the time the first snow of winter falls, you're accustomed to driving
				on clean, safe roads. It's easy to get out of the habit of winter
				driving safety, so here are a few tips to consider before you turn the
				ignition this winter.
			</p>
			<h2 className="p-4 text-2xl font-semibold">Cold Weather Safety</h2>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				When the temperatures start to drop, it's more and more important to
				make sure that you are driving in a safe vehicle. Check the tire
				pressure and tread to make sure that they are at safe levels. Your tire
				shop can help you identify any problems with the tread or tire pressure.
				Remember that the tire pressure changes with the air temperature. If you
				know you will be frequently driving in snowy conditions, you might also
				consider purchasing snow tires that are designed to provide extra
				traction in the snow. Don't let your fuel supply drop too low. If you
				become stranded, your car is your primary source of heat. It's a good
				idea to fill up before it drops below 1/3 of a tank.
			</p>
			<h2 className="p-4 text-2xl font-semibold">
				Maintaining Vehicle Control
			</h2>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				When your tires come in contact with snow or ice, your ability to steer
				and slow your vehicle is greatly reduced. With this in mind, you should
				keep your speed and following distance at appropriate levels. The more
				ice there is, the slower you should go. This is not a time to race or
				try any crazy driving stunts. It's important to maintain full control of
				your vehicle at all times.
			</p>
			<h2 className="p-4 text-2xl font-semibold">Winter Storm Suggestions</h2>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				If there is a winter storm, you should be extra careful to drive only
				when necessary. Let someone know where you're going and what time you
				plan to return. If you have a cell phone, bring that along with a car
				charger. Bring a snow shovel, flashlight, blanket, and extra food and
				water. You want to be able to keep warm and visible if your vehicle
				becomes stuck. Check the weather forecast and news reports before you
				leave home. Beware of areas with high winds, drifting, and freezing
				rain. Stay well below the speed limit and extra far behind the person in
				front of you. Make sure that you always have plenty of fuel in your
				vehicle.
			</p>
		</>
	)
}
